import React from "react";
import styled from "styled-components";
import { Menu, Item } from "react-contexify";

import "react-contexify/dist/ReactContexify.css";
import { colors } from "../../Assets/styles/colors";
import { useTranslate } from '@tolgee/react';
import { ReactComponent as ForwardIcon } from "../../Assets/iconsv2/chatContextmenu/forward.svg";
import { ReactComponent as DeleteIcon } from "../../Assets/iconsv2/settings/delete.svg";
import { ReactComponent as CopyIcon } from "../../Assets/iconsv2/chatContextmenu/copy.svg";
import { ReactComponent as ReplyIcon } from "../../Assets/iconsv2/chatContextmenu/reply.svg";
import { ReactComponent as EditIcon } from "../../Assets/iconsv2/chatContextmenu/edit.svg";
import { ReactComponent as ReportIcon } from "../../Assets/iconsv2/chatContextmenu/report.svg";
import { ReactComponent as InfoIcon } from "../../Assets/icons/context-menu-icons/questionMarkIcon.svg";

const CustomItem = ({ text, icon, redButton }) => {
  return (
    <CustomItemContainer redButton={redButton}>
      <p>{text}</p>
      {icon}
    </CustomItemContainer>
  );
};



const RightClickMenu = ({
  handleDeleteMessage,
  contextMenuItem,
  handleReportMessage,
  handleForwardMessage,
  handleEditMessageOption,
  handleReplyMessageOption,
  selectedConversation,
  user,
  conversations,
  handleCopyOption,
  currentConversationMessages,
  handleInfoOption,
  variant = "normal",
  menuId = "menu-id",
}) => {
  const { t } = useTranslate();
  const buttonList = [
    {
      id: "reply",
      text: t('chat.reply'),
      icon: <ReplyIcon />,
    },
    {
      id: "copy",
      text: t('general.copy'),
      icon: <CopyIcon />,
    },

    {
      id: "edit",
      text: t('general.edit'),
      icon: <EditIcon />,
    },

    {
      id: "forward",
      text: t('chat.forward'),
      icon: <ForwardIcon />,
    },
    {
      id: "report",
      text: t('chat.report'),
      icon: <ReportIcon />,
    },
    {
      id: "info",
      text: t('chat.info'),
      icon: <InfoIcon />,
    },
    {
      id: "delete",
      text: t('general.delete'),
      icon: <DeleteIcon />,
      redButton: true,
    },
  ];
  function handleItemClick({ id }) {
    switch (id) {
      case "delete":
        handleDeleteMessage(
          contextMenuItem.conversationId,
          contextMenuItem.messageId
        );
        break;
      case "report":
        handleReportMessage(
          contextMenuItem.conversationId,
          contextMenuItem.messageId
        );
        break;
      case "forward":
        handleForwardMessage();
        break;
      case "edit":
        handleEditMessageOption();
        break;
      case "reply":
        handleReplyMessageOption();
        break;
      case "copy":
        handleCopyOption(contextMenuItem?.messageObject);
        break;
      case "info":
        handleInfoOption(contextMenuItem?.messageObject);
        break;

      default:
        break;
    }
  }

  const chefIfUserIsAnonymous = () => {
    if (!contextMenuItem) {
      return;
    }
    if (!contextMenuItem.messageObject) {
      return;
    }

    if (!selectedConversation) {
      return;
    }
    let isUserAnonymous = user.phone_number === ""
    return isUserAnonymous

  }

  const checkIfLastMessage = () => {
    if (!contextMenuItem) {
      return;
    }

    if (!contextMenuItem.messageObject) {
      return;
    }

    if (!selectedConversation) {
      return;
    }

    let myMessages = [];

    currentConversationMessages.forEach((element) => {
      if (element.user_id === user.id) {
        myMessages.push(element);
      }
    });

    const lastMessageFromList = myMessages.pop();

    if (contextMenuItem.messageObject.id === lastMessageFromList?.id) {
      return true;
    } else {
      return false;
    }
  };

  const checkIfIsMymessage = () => {
    if (!contextMenuItem) {
      return;
    }

    if (!contextMenuItem.messageObject) {
      return;
    }

    if (!selectedConversation) {
      return;
    }

    let isMyMessage = user.id === contextMenuItem?.messageObject?.user_id;
    return isMyMessage;
  };


  const filterButtons = (buttons) => {
    let availableOptions = buttons;

    if (variant === "call_chat") {
      let filteredButtons = buttons.filter(item => 
        item.id === "reply" || 
        item.id === "copy" ||
        item.id === "edit" || 
        item.id === "delete"
      );
    if (!contextMenuItem || !contextMenuItem.messageObject) {
        return filteredButtons;
      }

      let lastMessage = checkIfLastMessage();
      let myMessage = checkIfIsMymessage();

      if (contextMenuItem.messageObject?.image || 
          contextMenuItem.messageObject?.video || 
          contextMenuItem.messageObject?.document) {
        filteredButtons = filteredButtons.filter((item) => item.id !== "copy");
      }

      if (!lastMessage || !myMessage) {
        filteredButtons = filteredButtons.filter((item) => item.id !== "edit");
      }

      if (myMessage) {
        filteredButtons = filteredButtons.filter((item) => item.id !== "reply");
      }
      
      if (contextMenuItem.messageObject?.deleted) {
        return [];
      }

      return filteredButtons;
    }

    if (!contextMenuItem || !contextMenuItem.messageObject) {
      return availableOptions;
    }

    let lastMessage = checkIfLastMessage();
    let myMessage = checkIfIsMymessage();
    let quickChat = selectedConversation?.quick_chat;
    let anonymousUser = chefIfUserIsAnonymous()

    if (contextMenuItem.messageObject?.deleted) {
      availableOptions = buttons.filter((item) => item.id == "report");
    }

    if (contextMenuItem.messageObject?.image) {
      availableOptions = buttons.filter((item) => item.id != "copy");
    }

    if (!lastMessage || !myMessage) {
      availableOptions = availableOptions.filter((item) => item.id != "edit");
    }

    if (myMessage) {
      availableOptions = availableOptions.filter((item) => item.id != "reply");
    }
    if (!myMessage || anonymousUser) {
      availableOptions = availableOptions.filter((item) => item.id != "info");
    }

    if (quickChat) {
      availableOptions = availableOptions.filter(
        (item) => item.id != "forward" && item.id != "delete"
      );
    }

    return availableOptions;
  };

  return (

    <StyledMenu id={menuId} className="styledMenu">
      {contextMenuItem?.messageObject?.mood && checkIfIsMymessage() &&
        <ComplementaryMessageInfoWrapper>
          <ComplementaryMessageInfoElement>
            {t('context_menu.message_mood_info_text')}{" "}
            <span>{contextMenuItem?.messageObject?.mood}</span>
          </ComplementaryMessageInfoElement>
        </ComplementaryMessageInfoWrapper>
      }
      {filterButtons(buttonList).map((item, index) => (
        <Item onClick={handleItemClick} id={item.id} key={index}>
          <CustomItem
            text={item.text}
            icon={item.icon}
            redButton={item.redButton}
          />
        </Item>
      ))}
    </StyledMenu>
  );
};

export default RightClickMenu;

const ComplementaryMessageInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
    background: ${({ theme }) => theme.menu.groupContentBackground};
  position: relative;
  backdrop-filter: blur(10px);
  padding: 10px 16px;
  border-radius: 12px 12px 0 0;
  width:100%;
min-width:265px;
`;
const ComplementaryMessageInfoElement = styled.p`
  font-size: 12px;
  line-height: 14px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
  span {
       color: ${({ theme }) => theme.menu.selectedTextColor};
    font-weight: 600;
    text-transform:capitalize;
  }
`;

const CustomItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: ${({ theme, redButton }) => redButton ? theme.menu.deleteColor : theme.menu.secondaryTextColor};
   padding: 6px 10px;
  svg {
    height: 20px;
    width: 20px;

  }

`;

const StyledMenu = styled(Menu).attrs({
  // custom props
})`
overflow:hidden;

  background: transparent;
  color: white;
  padding: 0;
  border-radius: 12px;
  .contexify_item {
    background: ${({ theme }) => theme.menu.background};
    border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);

    &:last-child {
      border-bottom: none;
      border-radius: 0 0 12px 12px;
    }
  }
  .contexify_itemContent {
    color: ${colors.errorColor};
  }
  .contexify_item:not(.contexify_item-disabled):hover > .contexify_itemContent,
  .contexify_item:not(.contexify_item-disabled):focus > .contexify_itemContent {
    color: inherit;
   background: ${({ theme }) => theme.chat.selectedBackground};
  }
`;
